import {
  CoachCuratedDayToDayTag,
  CoachCuratedFoodTag,
  CoachCuratedSymptomTag,
  UserSuggestedSymptomTag,
  CoachCuratedDiagnosisTag,
  UserSuggestedDiagnosisTag,
} from '../tags';
import { ObjectId } from 'bson';
import { Genders } from '../static/genders';

export enum CustomData {
  ADMIN = 'AdminCustomDatum',
  COACH = 'CoachCustomDatum',
  MEMBER = 'MemberCustomDatum',
}
export type AdminCustomDatum = {
  _id: ObjectId;
  __typename?: CustomData;
  admin_id: string;
  is_enabled: boolean;
  first_name: string;
  last_name: string;
  email: string;
  picture?: string;
  phone_number?: string;
  address?: string;
  country?: string | null;
  state?: string;
  city?: string;
  zip_code?: string;
};

export type MemberCustomDatum = {
  _id: ObjectId;
  __typename?: CustomData;
  member_id: string;
  coach_id: string | null;
  is_enabled: boolean;
  first_name?: string;
  last_activity?: Date;
  last_name?: string;
  email: string;
  picture?: string;
  phone_number?: string;
  address?: string;
  country?: string | null;
  state?: string;
  city?: string;
  zip_code?: string;
  birthdate?: Date | null;
  gender?: Genders | null;
  has_subscription?: boolean;
  nickname?: string;
  subscription_start_date?: Date | null;
  subscription_end_date?: Date | null;
  account_created_at?: Date;
  tags_day_to_day: CoachCuratedDayToDayTag[];
  tags_diagnosis: CoachCuratedDiagnosisTag[];
  tags_food: CoachCuratedFoodTag[];
  tags_symptom: CoachCuratedSymptomTag[];
  tags_user_symptom: UserSuggestedSymptomTag[];
  tags_user_diagnosis: UserSuggestedDiagnosisTag[];
};

export type CoachCustomDatum = {
  _id: ObjectId;
  __typename?: CustomData;
  coach_id: string;
  is_enabled: boolean;
  first_name: string;
  last_name: string;
  email: string;
  picture?: string;
  phone_number?: string;
  address?: string;
  country?: string | null;
  state?: string;
  city?: string;
  zip_code?: string;
  birthdate?: Date | null;
  gender?: Genders | null;
  acuity_access_token?: string;
  assigned_members: string[];
};

export type AssignCoachFn = (coach_id: string, member_id: string) => Promise<void>;
